import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    // Force a full page reload to ensure we get the latest version
    window.location.href = '/';
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
      <h1 className="text-4xl font-bold mb-4">Page Not Found</h1>
      <p className="text-lg text-gray-600 text-center mb-8">
        We couldn't find the page you're looking for. The site may have been updated.
      </p>
      <Button 
        onClick={handleGoHome}
        className="bg-primary hover:bg-primary/90"
      >
        Go to Homepage
      </Button>
    </div>
  );
};

export default NotFoundPage;